import { Anchor, Container, Stack, Text, Title } from '@mantine/core';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/** The public page. Signed in editors never see it, they go straight to their interactions. */
export function Landing() {
  const { status } = useAuth();

  if (status === 'signed_in') return <Navigate to="/interactions" replace />;

  return (
    <Container component="main" size={560} pt={140} pb={80}>
      <Stack gap="lg">
        <Title order={1}>quizee</Title>
        <Text size="lg">
          Quizzes, polls, surveys and forms for news publishers. One script tag, no redeploys, every
          response captured as first-party data.
        </Text>
        <Text c="dimmed">
          <Anchor component={Link} to="/login">
            Sign in
          </Anchor>{' '}
          to build a poll, or{' '}
          <Anchor component={Link} to="/signup">
            set up a publisher account
          </Anchor>
          .
        </Text>
        <Text component="footer" size="sm" c="dimmed" mt="xl">
          <Anchor href="mailto:hello@quizee.io" c="dimmed" size="sm">
            hello@quizee.io
          </Anchor>
        </Text>
      </Stack>
    </Container>
  );
}
